import React from 'react'

export const widgetContextSettings = {
  isWidget: false,
  isWidgetFullSize: false,
  isWidgetActive: false,
  initialWidgetFeature: null,
  handleCloseWidget: function() {},
  // Iframe's document
  frameDocument: null,
  // Iframe's window
  frameWindow: null,
}

export const WidgetContext = React.createContext(widgetContextSettings)
